module.exports = __webpack_public_path__ + "static/media/search.55a3ea3e.svg";